<template>
  <section class="h_14">
    <div class="alive_content f-select-center" v-ia>
      <div class="alive_card">
        <m-img
          class="alive_title"
          src="@/v2/mobile/assets/image/h_14_title1.svg"
        ></m-img>
        <m-video
          ref="video1"
          autoplay
          muted
          loop
          disablepictureinpicture
          x5-playsinline
          playsinline
          webkit-playsinline="true"
          src="@/v2/auto/assets/video/36/0.mp4"
        />
        <div class="card_bottom">
          <replay
            class="alive_replay"
            @click="() => replayVideo(this.$refs.video1)"
          />
        </div>
      </div>
      <div class="alive_card">
        <m-img
          class="alive_title"
          src="@/v2/mobile/assets/image/h_14_title2.svg"
        ></m-img>
        <m-video
          ref="video2"
          autoplay
          muted
          loop
          disablepictureinpicture
          x5-playsinline
          playsinline
          webkit-playsinline="true"
          src="@/v2/auto/assets/video/36/1.mp4"
        />
        <div class="card_bottom">
          <replay
            class="alive_replay"
            @click="() => replayVideo(this.$refs.video2)"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { videoPlayByVisibleAreaH5, replayVideo } from '@/utils'
import replay from '@/components/replay.vue'
export default {
  components: { replay },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    const { video1, video2 } = this.$refs
    // 监听屏幕宽度变化
    video1 && videoPlayByVisibleAreaH5(video1)
    video2 && videoPlayByVisibleAreaH5(video2)
  },
  methods: {
    replayVideo,
  },
}
</script>

<style lang="less" scoped>
.h_14 {
  width: 100%;
  background: #ffffff;
  height: 100%;
  display: flex;
  z-index: 86;
  position: relative;
  margin-top: -5px;
  justify-content: center;
  align-items: center;
  .alive_content {
    margin-top: 5px;
    padding: 0 24px 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    .alive_card {
      flex: 1;
      position: relative;
      border-radius: 12px;
      overflow: hidden;
      background-color: #f4f4f5;
      .alive_title {
        width: 80%;
        margin: 24px;
      }
      video {
        width: 100%;
        margin-left: 24px;
        margin-top: 24px;
        border-top-left-radius: 24px;
      }
    }
    .card_bottom {
      position: absolute;
      bottom: 0;
      width: 100%;
      background: linear-gradient(
        to bottom,
        rgba(242, 246, 250, 0) 0.85%,
        #f2f6fa 90%
      );
      height: 60px;
      .alive_replay {
        color: #3b82fc;
        position: absolute;
        bottom: 16px;
        left: 24px;
      }
    }
  }
}
</style>
